import { IOptionsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const optionsSelector = (state: RootState) => state.options;

const optionsListSelector = createSelector([optionsSelector], (options: IOptionsInitialState) => options.optionsList);

const optionSelector = createSelector([optionsSelector], (options: IOptionsInitialState) => options.option);

export const optionsSel = {
    optionsSelector,
    optionSelector,
    optionsListSelector,
};
